<template>
    <div class="typeahead-group">
    <div v-show="myValue.value === null">
        <i class="fa fa-spinner fa-spin" v-if="loading"></i>
        <input type="text" class="form-control " :placeholder="placeholder" autocomplete="off" v-model="query" @keydown.down="down" @keydown.up="up" @keydown.enter="hit" @keydown.esc="onKeyUpEsc" @blur="onBlur" @input="update" :autofocus="typeof preventAutofocus !== 'undefined' && !preventAutofocus ? false : true">
        <ul v-show="hasItems">
          <li v-for="(item, $item) in items" :key="item.id" :class="activeClass($item)" @mousedown="hit" @mousemove="setActive($item)">
            <span v-text="item.name"></span>
          </li>
        </ul>
    </div>
    <i v-show="myValue.value !== null" class="fa fa-times reset" @click="resetTypeahead"></i>
    <input v-show="myValue.value !== null" type="text" class="form-control typeahead-value" v-model="myValue.label" readonly>
    </div>
</template>

<script>
import VueTypeahead from 'vue-typeahead'

export default {
  props: ['model', 'dataLineIndex', 'item', 'urlSearch', 'formType', 'placeholder', 'labelFields', 'arrResponse', 'customQueryParamName', 'preventAutofocus', 'type'],
  extends: VueTypeahead,
  data () {
    return {
      isHide: false,
      myValue: {
        value: null,
        label: null,
        quantity: null,
        sellingPrice: null,
        capitalPrice: null
      },
      src: this.urlSearch,
      data: {},
      limit: 100,
      minChars: 3,
      selectFirst: false,
      queryParamName: 'q'
    }
  },
  beforeMount () {
    if (typeof this.customQueryParamName !== 'undefined') {
      this.queryParamName = this.customQueryParamName
    }
    this.myValue.value = this.model.value
    this.myValue.label = this.model.label
  },
  watch: {
    urlSearch: function (val) {
      this.src = val
    }
  },
  methods: {
    onBlur () {
      this.reset()
      this.$emit('onblur')
      this.isHide = false
    },
    onKeyUpEsc () {
      this.reset()
      this.$emit('onkeyupesc')
    },
    onHit (item) {
      if (typeof item !== 'undefined') {
        this.myValue.value = item.id
        this.myValue.label = item.name
        this.myValue.quantity = item.quantity
        this.myValue.capitalPrice = item.capitalPrice
        this.myValue.sellingPrice = item.sellingPrice
        this.myValue.memberPrice = item.memberPrice !== undefined ? item.memberPrice : null
        this.myValue.smPrice = item.smPrice !== undefined ? item.smPrice : null
        this.myValue.more3 = item.more3 !== undefined ? item.more3 : null
        this.myValue.more12 = item.more12 !== undefined ? item.more12 : null
        this.myValue.category = item.category
        this.myValue.count_point = item.count_point
        this.model.value = item.id
        this.model.label = item.name
        this.model.quantity = item.quantity
        this.model.capitalPrice = item.capitalPrice
        this.model.sellingPrice = item.sellingPrice
        this.model.memberPrice = item.memberPrice !== undefined ? item.memberPrice : null
        this.model.smPrice = item.smPrice !== undefined ? item.smPrice : null
        this.model.more3 = item.more3 !== undefined ? item.more3 : null
        this.model.more12 = item.more12 !== undefined ? item.more12 : null
        this.model.dropshipper = item.dropshipper !== undefined ? item.dropshipper : null
        this.model.category = item.category
        this.model.count_point = item.count_point
        item.dataLineIndex = this.dataLineIndex
        this.doCreateCutomer(item)
      } else {
        this.doCreateCutomer(this.query)
        this.isHide = false
      }
    },
    resetField () {
      this.myValue.value = null
      this.myValue.label = null
    },
    resetTypeahead () {
      this.myValue.value = null
      this.myValue.label = null
      this.myValue.quantity = null
      this.myValue.capitalPrice = 0
      this.myValue.sellingPrice = 0
      this.myValue.memberPrice = 0
      this.myValue.smPrice = 0
      this.myValue.more3 = 0
      this.myValue.more12 = 0
      this.model.value = null
      this.model.label = null
      this.model.quantity = null
      this.model.capitalPrice = 0
      this.model.sellingPrice = 0
      this.model.memberPrice = 0
      this.model.smPrice = 0
      this.model.more3 = 0
      this.model.more12 = 0
      this.model.dropshipper = 0
      this.model.category = null
      this.model.count_point = 0
      this.doCreateCutomer({dataLineIndex: this.dataLineIndex, isRemove: true})
    },
    prepareResponseData (data) {
      this.isHide = data.length === 0
      let resp = []
      data = this.arrResponse === null ? data : data.data
      data.forEach((d) => {
        let r = {
          id: d.id,
          name: '',
          capitalPrice: d.capital_price,
          sellingPrice: d.selling_price,
          smPrice: d.sm_price,
          memberPrice: d.member_price,
          more3: d.more_3,
          more12: d.more_12,
          dropshipper: d.dropshipper,
          count_point: d.count_point,
          category: d.customer_category !== undefined ? d.customer_category.name : null
        }
        this.labelFields.forEach((label, quantity, i) => {
          r.name += (i ? '' : '') + (d[label] !== null ? d[label] : '')
        })
        resp.push(r)
      })
      return resp
    },
    doCreateCutomer (query) {
      this.$emit('doCreateCutomer', query)
    }
  }
}
</script>

<style lang="sass" scoped>
  .input-typeahead
    .typeahead-group
      position: relative
    .fa
      width: unset
    .fa-spin
      right: 0px
      padding: 15px 15px
      position: absolute
    .reset
      top: 14px
      right: 8px
      cursor: pointer
      position: absolute
      color: #888
      font-size: 13px
      text-align: center
      font-style: normal
    ul
      z-index: 99999999
      list-style: none
      padding: 0
      color: #000
      background: rgb(237, 239, 240)
      position: absolute
      min-width: 200px
      li
        padding: 10px
        border-bottom: 1px solid rgba(0, 0, 0, 0.06)
        &.active
          background: #03ACEF
          color: #fff
</style>



// WEBPACK FOOTER //
// src/components/Typeahead.vue